<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 24 24" fill="none"
        :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 3C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3H8ZM13.4 9.60156C13.4 9.27019 13.6686 9.00156 14 9.00156H17.5355C17.8669 9.00156 18.1355 9.27019 18.1355 9.60156L18.1355 13.1371C18.1355 13.4685 17.8669 13.7371 17.5355 13.7371C17.2042 13.7371 16.9355 13.4685 16.9355 13.1371V11.4116L14.2508 14.2161C13.6853 14.8068 12.751 14.8358 12.1501 14.2813L10.0184 12.3145C9.98012 12.2791 9.9211 12.2791 9.8828 12.3145L7.17391 14.8139C6.88977 15.0761 6.44692 15.0583 6.18476 14.7741C5.92259 14.49 5.9404 14.0471 6.22453 13.785L8.93342 11.2855C9.50795 10.7554 10.3933 10.7554 10.9678 11.2855L13.0994 13.2524C13.1395 13.2893 13.2018 13.2874 13.2395 13.248L16.1559 10.2016L14 10.2016C13.6686 10.2016 13.4 9.93293 13.4 9.60156Z"
            :fill="fillColor" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ChartIcon',
    props: {
        fillColor: {
            type: String,
            default: '#84838C'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        class: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const className = props.class;
        return {
            className
        };
    }
});
</script>